module.exports = __webpack_public_path__ + "review_tool_wasm.e9ccea8a.wasm";